import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Pencil, ChevronRight } from 'lucide-react';
import { pagesApi } from '../api/cms';
import { defaultPages } from '../api/defaults';
import type { PageContent } from '../types';

export default function PagesPage() {
  const [pages, setPages] = useState<PageContent[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    pagesApi.list()
      .then(setPages)
      .catch(() => setPages(defaultPages))
      .finally(() => setLoading(false));
  }, []);

  // 18 pages list (from main site)
  const allPages = [
    { id: 'home', name: 'Pagina Principală', path: '/' },
    { id: 'webdesign', name: 'Web Design', path: '/servicii/web-design' },
    { id: 'callcenter', name: 'Call Center', path: '/servicii/call-center' },
    { id: 'hosting', name: 'Găzduire Web', path: '/servicii/gazduire' },
    { id: 'voip', name: 'Telefonie VoIP', path: '/servicii/telefonie-voip' },
    { id: 'crm', name: 'CRM & Software', path: '/servicii/crm-software' },
    { id: 'hardware', name: 'IT Hardware', path: '/servicii/it-hardware' },
    { id: 'contact', name: 'Contact', path: '/contact' },
    { id: 'clienti', name: 'Clienți', path: '/clienti' },
    { id: 'blog', name: 'Blog', path: '/blog' },
    { id: 'despre', name: 'Despre Noi', path: '/despre' },
    { id: 'termeni', name: 'Termeni & Condiții', path: '/termeni' },
    { id: 'confidentialitate', name: 'Politică de Confidențialitate', path: '/confidentialitate' },
    { id: 'gdpr', name: 'Politica GDPR', path: '/gdpr' },
    { id: 'cookies', name: 'Politica Cookies', path: '/cookies' },
    { id: 'retur', name: 'Politică de Retur', path: '/retur' },
    { id: 'nda', name: 'Acord de Confidențialitate (NDA)', path: '/nda' },
    { id: 'servicii-managed', name: 'IT Managed Services', path: '/servicii/managed-it' },
    { id: 'servicii-cybersec', name: 'Cybersecurity', path: '/servicii/cybersecurity' },
    { id: 'servicii-retele', name: 'Rețele & Infrastructure', path: '/servicii/retele' },
    { id: 'servicii-cloud', name: 'Cloud Solutions', path: '/servicii/cloud' },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Pagini</h1>
        <p className="text-white/40 text-sm mt-1">Editează conținutul paginilor site-ului.</p>
      </div>

      <div className="bg-[#07090f] border border-white/10 rounded-xl divide-y divide-white/5 overflow-hidden">
        {loading ? (
          <div className="p-8 text-center text-white/30 text-sm">Se încarcă...</div>
        ) : allPages.map(p => {
          const edited = pages.find(x => x.pageId === p.id);
          return (
            <Link key={p.id} to={`/pages/${p.id}`}
              className="flex items-center gap-4 px-5 py-4 hover:bg-white/[0.02] transition-colors group">
              <div className="flex-1 min-w-0">
                <div className="text-sm text-white font-medium">{p.name}</div>
                <div className="text-xs text-white/30 mt-0.5">{p.path}</div>
              </div>
              {edited && (
                <span className="text-xs text-[#4ab8ff] bg-[#295CA8]/20 px-2 py-0.5 rounded-full">Editat</span>
              )}
              <div className="flex items-center gap-2 text-white/30 group-hover:text-white/60 transition-colors">
                <Pencil size={14} />
                <ChevronRight size={14} />
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
